import React from 'react';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
  Menu,
  Block,
} from '@uncinc/react-drupal-core';

import {
  APP_OPTIONS,
} from '../../../../config/constants';

import MenuSocial from '../../SocialMenu';

import './style.scss';

const FOOTER_ITEM_SECTION_CONTACT = 'section-contact';
const FOOTER_ITEM_SECTION_SOCIAL = 'section-social';

const BuurtboerderijMenuFooter = () => (
  <div className="FooterMenu BuurtboerderijMenuFooter" id="BuurtboerderijMenuFooter">
    <Container>
      <Menu id="buurtboerderij-footer">
        {(items) => {
          return (
            <div className="row">
              {items.map((item) => {
                const key = item.getIn(['link', 'meta_data', 'entity_id']);
                const title = item.getIn(['link', 'title']);
                const sectionType = item.getIn(['link', 'options', 'attributes', 'class', 0], null);

                if (!title) {
                  return;
                }

                // Contact section.
                if (sectionType === FOOTER_ITEM_SECTION_CONTACT) {
                  return (
                    <div
                      key={`bb-footer-section-${key}`}
                      className="FooterMenu__item col-12 col-lg-6"
                    >
                      <h4>{title}</h4>
                      <div className="row">
                        <div className="FooterMenu__item__link col-12 col-md-6">
                          <Block id={APP_OPTIONS.parameters.blockIdBuurtboerderijFooterContact} />
                        </div>
                        <div className="FooterMenu__item__link col-12 col-md-6">
                          <Block id={APP_OPTIONS.parameters.blockIdBuurtboerderijFooterOpeningHours} />
                        </div>
                      </div>
                    </div>
                  );
                }

                // Social section.
                if (sectionType === FOOTER_ITEM_SECTION_SOCIAL) {
                  return (
                    <div
                      key={`bb-footer-section-${key}`}
                      className="FooterMenu__item col-12 col-md-6 col-lg-3"
                    >
                      <h4>{title}</h4>
                      <MenuSocial id="buurtboerderij-social" />
                    </div>
                  );
                }


                // Default menu section.
                return (
                  <div
                    key={`bb-footer-section-${key}`}
                    className="FooterMenu__item col-12 col-md-6 col-lg-3"
                  >
                    <h4>{title}</h4>

                    {/* Render the menu items inside the section */}
                    {item.getIn(['subtree']).map((subItem, index) => {
                      const url = subItem.getIn(['link', 'url']);
                      const linkTitle = subItem.getIn(['link', 'title'], '');

                      return (
                        <div key={`bb-footer-item-${index}`}>
                          <CoreLink
                            className="FooterMenu__item__link"
                            to={url}
                          >
                            {linkTitle}
                          </CoreLink>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          );
        }}
      </Menu>
    </Container>
  </div>
);

export default BuurtboerderijMenuFooter;
